import styles from './DislikeCommentButton.module.scss'
import { Record, Function, Boolean, Number, Static } from 'runtypes'

export const DislikeCommentButtonProps = Record({
  dislikeHandler: Function,
  isDisliked: Boolean,
  isLiked: Boolean,
  numberOfDislikes: Number,
})

export type DislikeCommentButtonProps = Static<typeof DislikeCommentButtonProps>

// @TODO remove this
const DislikeCommentButton = ({
  dislikeHandler,
  /* eslint-disable @typescript-eslint/no-unused-vars */
  isDisliked,
  isLiked,
  numberOfDislikes,
}: DislikeCommentButtonProps) => {
  return (
    <div className={`${styles.DislikeCommentButton} flex w-16`}>
      <p className="text-grayText mr-0.5">{numberOfDislikes}</p>
      <svg
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        className={`${styles.DislikeButton} ${
          isDisliked || isLiked ? null : 'cursor-pointer'
        } pt-1`}
        onClick={
          (isDisliked !== undefined && isDisliked) || isLiked
            ? null
            : dislikeHandler
        }
      >
        <g data-name="1" id="_1">
          <path d="M242.28,427.39a43.85,43.85,0,0,1-13.1-2c-18.22-5.69-29.87-21.64-29.69-40.62.16-17.35-3.15-32.5-9.83-45-8.19-15.33-21.83-27.13-40.55-35.08A15,15,0,1,1,160.83,277c45.4,19.26,69.14,56.6,68.65,108a12.28,12.28,0,0,0,22.33,7c28.34-41.71,3.47-87.63,3.22-88.09a15,15,0,0,1,13.12-22.27H409.79a14.22,14.22,0,0,0,0-28.43H389.34a15,15,0,1,1,0-30,14.2,14.2,0,0,0,14.21-14.21,14.23,14.23,0,0,0-14.21-14.21H368.9a15,15,0,0,1,0-30,14.21,14.21,0,1,0,0-28.42H348.45a15,15,0,0,1,0-30,14.21,14.21,0,1,0,0-28.42H261.8a111.69,111.69,0,0,0-39.07,7l-67.5,25.07A15,15,0,0,1,144.78,82l67.5-25.07A141.5,141.5,0,0,1,261.8,48h86.65a44.25,44.25,0,0,1,40,63,44.27,44.27,0,0,1,20.45,58.43,44.27,44.27,0,0,1,20.44,58.42,44.21,44.21,0,0,1-19.59,83.84H290.11c6.77,23.11,11.23,60.85-13.48,97.22A41.21,41.21,0,0,1,242.28,427.39Z" />
          <path d="M155,305.85H69.13a15,15,0,0,1-15-15V85.21a15,15,0,0,1,15-15H155a15,15,0,0,1,15,15V290.85A15,15,0,0,1,155,305.85Zm-70.84-30H140V100.21H84.13Z" />
        </g>
      </svg>
    </div>
  )
}

export default DislikeCommentButton
